export function normalizeImageUrl(url) {
  if (!url) return url;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.pathname.startsWith('/api/')) return parsed.pathname;
  } catch {}
  return url;
}
